import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useCategory from "../hooks/useCategory";

const CategoryMenu = ({ open, handleClose, anchorEl }: any) => {
  const navigate = useNavigate();
  const { categories } = useCategory();

  return (
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          border: "1px solid rgba(1, 18, 36, 0.08)",
          boxShadow: "6px -3px 12px 0px rgba(0, 0, 0, 0.05)",
          width: "256px",
          borderRadius: "8px",
          li: {
            fontSize: "14px",
            fontWeight: 800,
            padding: "12px 16px",
          },
          ".lang": {
            fontSize: "12px",
            fontWeight: 600,
            color: "rgba(128, 137, 146, 1)",
          },

          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          "&::before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
      {categories.map((el: any) => (
        <>
          <MenuItem key={el.id}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                whiteSpace: "normal",
              }}
              key={el.id}
              onClick={() => navigate(`/search/${el.id}`)}>
              {el.name}
            </Box>
          </MenuItem>
        </>
      ))}
    </Menu>
  );
};
export default CategoryMenu;
